import React from "react";
import SpecialOffer from "../../assets/svg/SpecialOffer";

const SingleOrderDetail = ({ mt, data }) => {
  return (
    <div
      className={`bg-white p-4 rounded-lg shadow-sm border border-[#00000010] ${mt} flex items-start gap-3`}
    >
      <div className="w-16 h-auto aspect-square">
        <img src={data?.image} alt={data?.product_title} />
      </div>
      <div>
        <p className="text-[15px] supreme-medium leading-[18px]">
          {data?.product_title} - {data?.variant_title}
        </p>
        <p className="text-[14px] general-sans-medium mt-2">
          Qty: {data?.quantity}
        </p>
        {data?.properties?.upsell_discount ? (
          <div className="flex items-center gap-2 mt-3">
            <SpecialOffer />
            {data?.properties?.upsell_price ? (
              <p className="text-[14px] general-sans-medium text-[#c00]">
                ₹{data?.properties?.upsell_price}
              </p>
            ) : (
              <></>
            )}

            {data?.price ? (
              <p className="text-[14px] general-sans-medium line-through text-gray-400">
                ₹{data?.price / 100}
              </p>
            ) : (
              <></>
            )}

            <p className="text-[12px] general-sans-medium text-[#c00]">
              Special offer
            </p>
          </div>
        ) : (
          <div className="flex items-center gap-2 mt-3">
            {data?.price ? (
              <p className="text-[14px] general-sans-medium">
                ₹{data?.price / 100}
              </p>
            ) : (
              <></>
            )}

            {data?.compare_at_price && data?.compare_at_price / 100 > 0 ? (
              <p className="text-[14px] general-sans-medium text-gray-400 line-through">
                ₹{data?.compare_at_price / 100}
              </p>
            ) : (
              <></>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleOrderDetail;
